import { useState } from 'react';

// Mirrors buildVimeoEmbedURL in App.jsx — same params, same player.
const buildSrc = (vimeoId, autoplay) => {
  const p = new URLSearchParams({ dnt: '1', color: '2D2D2D', title: '0', byline: '0', portrait: '0', autoplay: autoplay ? '1' : '0' });
  return `https://player.vimeo.com/video/${vimeoId}?${p.toString()}`;
};

export default function VimeoFacade({ vimeoId, title = 'Video', poster }) {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="vf-player">
        <iframe
          src={buildSrc(vimeoId, true)}
          title={title}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <button type="button" className="vf-poster" onClick={() => setPlaying(true)} aria-label={`Play ${title}`}>
      {poster ? (
        <img src={poster} alt="" width="1280" height="720" loading="lazy" decoding="async"/>
      ) : (
        <div className="vf-poster-blank" aria-hidden="true"/>
      )}
      <span className="vf-play-indicator" aria-hidden="true">
        <svg viewBox="0 0 60 60" width="60" height="60">
          <circle cx="30" cy="30" r="29" fill="none" stroke="rgba(250,247,242,0.9)" strokeWidth="1.5"/>
          <path d="M 24 18 L 24 42 L 44 30 Z" fill="rgba(250,247,242,0.95)"/>
        </svg>
        <span className="vf-label">Watch the film</span>
      </span>
    </button>
  );
}
